import { render, staticRenderFns } from "./salesPaymentAction.vue?vue&type=template&id=2b0a4ad0&scoped=true"
import script from "./salesPaymentAction.vue?vue&type=script&lang=js"
export * from "./salesPaymentAction.vue?vue&type=script&lang=js"
import style0 from "./salesPaymentAction.vue?vue&type=style&index=0&id=2b0a4ad0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0a4ad0",
  null
  
)

export default component.exports